import { render } from "./SearchPeopleGroupsInput.vue?vue&type=template&id=0d38906a"
import script from "./SearchPeopleGroupsInput.vue?vue&type=script&lang=js"
export * from "./SearchPeopleGroupsInput.vue?vue&type=script&lang=js"

import "./SearchPeopleGroupsInput.vue?vue&type=style&index=0&id=0d38906a&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__